var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack513({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.36,10.68l1.12.35a2.53,2.53,0,0,1-.86,1.4,2.47,2.47,0,0,1-1.52.45,2.47,2.47,0,0,1-1.88-.78A3,3,0,0,1,5.49,10a3.15,3.15,0,0,1,.74-2.22A2.52,2.52,0,0,1,8.17,7a2.41,2.41,0,0,1,1.71.62,2.26,2.26,0,0,1,.58,1.05l-1.14.28a1.24,1.24,0,0,0-.43-.71A1.2,1.2,0,0,0,8.11,8a1.31,1.31,0,0,0-1,.45,2.22,2.22,0,0,0-.4,1.48,2.41,2.41,0,0,0,.39,1.55,1.26,1.26,0,0,0,1,.46,1.17,1.17,0,0,0,.79-.29A1.75,1.75,0,0,0,9.36,10.68Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack513);
export default __webpack_public_path__ + "static/media/Symbolpack_5_13.578a9004223535403b282350a6bfde1a.svg";
export { ForwardRef as ReactComponent };